<app-service-detail>
    <app-variables-tabs primarySelectedTab="CrossTables" class="container-fluid px-5">
    </app-variables-tabs>
    <div class="col-12 pl-md-5 ml-auto list-header">

        <h1 class="list-header-title">
            {{'Docs / Registrations' | translate}}
            <span (click)="switchHeadings()"
                  class="addBtn services-icon--add ml-2"
                  style="position:relative;top:-5px;">{{'Turn Table' | translate}}</span>
        </h1>
    </div>
    <div class="col-12 pl-5">
        <div class="row">
            <div class="col-md-12">
                <div class="row"
                         style="margin: 1rem 0">
                        <div class="col-md-12 col-12">
                            <ul class="list-inline float-right legend-list">
                                <li>
                                    <span class="badge badge-toUpload badge-letter higher">U</span> {{ 'modal.requirement_to_upload' | translate }}
                                </li>
                                <li>
                                    <span class="badge badge-toShow badge-letter higher">S</span> {{'modal.requirement_to_show' | translate }}
                                </li>
                                <li>
                                    <span class="badge badge-toSign badge-letter higher">M</span> {{'modal.requirement_to_sign' | translate }}
                                </li>
                                <!--li>
                                <span class="badge badge-warning badge-letter">PU</span> {{ 'modal.requirement_to_print_upload' | translate }}
                                      </li-->
                                <li>
                                    <span class="badge badge-physical badge-letter higher">P</span> {{'modal.result_is_physical' | translate }}
                                </li>
                                <li>
                                    <span class="badge badge-digital badge-letter higher">D</span> {{'modal.result_is_digital' | translate }}
                                </li>
                            </ul>
                        </div>
                    </div>
                <section class="table-container cross-table-container">                    
                    <div class="row">
                        <div class="col-md-12 col-12">
                            <div class="panel panel-disabled">
                                <section class="table-flip-scroll">
                                    <table class="table table-bordered table-striped cross-table">
                                        <thead>
                                            <tr>
                                                <th>&nbsp;</th>
                                                <th *ngFor="let item of documentRequestRegistrations[0]; let i = index; ">
                                                    <span class="limited">
                                                        {{ tableSwitched ? documentRequestRegistrations[0][i].requirementName : documentRequestRegistrations[0][i].registrationShortName && documentRequestRegistrations[0][i].registrationShortName !== "" ? documentRequestRegistrations[0][i].registrationShortName : documentRequestRegistrations[0][i].registrationName}}
                                                    </span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let row of documentRequestRegistrations; let i = index;">
                                                <td>{{tableSwitched ? row[0].registrationName : row[0].requirementName}}</td>
                                                <td class="cursor-hand"
                                                    *ngFor="let col of row; let j = index;"
                                                    (click)="editDocument(documentRequestRegistrations[i][j])">

                                                    <span *ngIf="documentRequestRegistrations[i][j].toUpload"
                                                          class="badge badge-toUpload badge-letter mr-1"
                                                          tooltip="{{ 'modal.requirement_to_upload' | translate }}">U</span>
                                                    <span *ngIf="documentRequestRegistrations[i][j].toShow"
                                                          class="badge badge-toShow badge-letter mr-1"
                                                          tooltip="{{ 'modal.requirement_to_show' | translate }}">S</span>
                                                    <span *ngIf="documentRequestRegistrations[i][j].toSign"
                                                          class="badge badge-toSign badge-letter mr-1"
                                                          tooltip="{{ 'modal.requirement_to_sign' | translate }}">M</span>
                                                    <!--span class="badge badge-danger badge-letter" style="margin:0 0.5rem"
                                                          *ngIf="documentRequestRegistrations[i][j].toPrintUpload">PU</span-->
                                                    <span *ngIf="documentRequestRegistrations[i][j].physicalResult"
                                                          class="badge badge-physical badge-letter mr-1"
                                                          tooltip="{{ 'modal.result_is_physical' | translate }}">P</span>
                                                    <span *ngIf="documentRequestRegistrations[i][j].dematerializedResult"
                                                          class="badge badge-digital badge-letter mr-1"
                                                          tooltip="{{ 'modal.result_is_digital' | translate }}">D</span>

                                                    <div *ngIf="documentRequestRegistrations[i][j]?.determinants && documentRequestRegistrations[i][j]?.determinants.length > 0">
                                                        <ul class="list-unstyled">
                                                            <li class="text-muted"
                                                                *ngFor="let det of documentRequestRegistrations[i][j]?.determinants">
                                                                <span *ngIf="det">{{ 'general.if' | translate }} {{det.name}}</span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </section>
                            </div>
                        </div>
                    </div>
                    <span class="hidden"
                          #trans_requirement_to_upload>{{'modal.requirement_to_upload'| translate }}</span>
                    <span class="hidden"
                          #trans_requirement_to_show>{{ 'modal.requirement_to_show' | translate }}</span>
                    <span class="hidden"
                          #trans_requirement_to_sign>{{ 'modal.requirement_to_sign' | translate }}</span>
                    <span class="hidden"
                          #trans_result_is_physical>{{ 'modal.result_is_physical' | translate }}</span>
                    <span class="hidden"
                          #trans_result_is_digital>{{ 'modal.result_is_digital' | translate }}</span>
                    <span class="hidden"
                          #trans_requirement_to_print_upload>{{ 'modal.requirement_to_print_upload' | translate }}</span>
                </section>
            </div>
        </div>
    </div>
</app-service-detail>

<modal [show]="showModal"
       [showClose]="true"
       [large]="false"
       [headerText]="'Add options'"
       (onClose)="onCancel()">
    <document-registration-modal [dematerialized_result]="dematerialized_result"
                                 [physical_result]="physical_result"
                                 [requirement_to_show]="requirement_to_show"
                                 [requirement_to_sign]="requirement_to_sign"
                                 [requirement_to_upload]="requirement_to_upload"
                                 [requirementRegistration]="selectedDocumentRequirementRegistration"
                                 (onCancel)="onCancel()"
                                 (onSave)="updateDocumentRequestRegistration()"
                                 (onChange)="selectedDocumentRequirementRegistration = $event.requirementRegistration">
    </document-registration-modal>
</modal>